var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllegril(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1453_23703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.8367 130.324C100.825 130.324 129.999 101.15 129.999 65.1619C129.999 29.174 100.825 0 64.8367 0C28.8488 0 -0.325195 29.174 -0.325195 65.1619C-0.325195 101.15 28.8488 130.324 64.8367 130.324Z",
    fill: "#FF87EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.325195 65.1619C-0.325195 101.151 28.848 130.324 64.8367 130.324C100.825 130.324 129.999 101.151 129.999 65.1619H-0.325195Z",
    fill: "#FFA6F0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1453_23703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.3178 74.686C72.5553 73.0588 77.8436 68.5841 80.6912 62.7534C81.6404 60.7194 82.1828 58.0075 80.42 56.6515C79.1996 55.7023 77.5724 55.9735 76.0809 56.1091L52.3513 59.9059C49.097 60.4482 45.4358 61.3974 45.029 65.3298C44.7578 67.7705 45.8426 70.7537 47.741 72.3808C52.0801 75.9064 61.3007 76.042 66.3178 74.686Z",
    fill: "#3D0E6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1646 74.8213C57.6393 75.9061 62.9276 75.6349 66.3175 74.6857C67.5379 74.4145 68.6227 73.8721 69.843 73.4653C67.9447 68.7194 62.9276 66.2787 58.4529 67.9058C55.4697 68.9906 53.5713 71.7026 53.1646 74.8213Z",
    fill: "#FF7192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7238 46.4816C42.7238 49.1936 40.5543 51.3631 37.8423 51.3631C34.9948 51.4987 32.8252 49.3292 32.8252 46.4816C32.8252 43.6341 34.9948 41.6001 37.7067 41.6001C40.5543 41.6001 42.7238 43.7697 42.7238 46.4816Z",
    fill: "#3D0E6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0804 46.4816C68.0804 49.1936 65.9108 51.3631 63.1989 51.3631C60.4869 51.3631 58.3174 49.1936 58.3174 46.4816C58.3174 43.7697 60.3513 41.6001 63.1989 41.6001C65.9108 41.6001 68.0804 43.7697 68.0804 46.4816Z",
    fill: "#3D0E6B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1453_23703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 130,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1453_23703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.75,
    height: 48.75,
    fill: "white",
    transform: "translate(32.8252 34.125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllegril);
export default __webpack_public_path__ + "static/media/allegril.8cb09b4c61eface5a7588d21b262a46d.svg";
export { ForwardRef as ReactComponent };